import { Gift } from "lucide-react";

export const GiftToggle = ({ isGift, onChange }) => (
  <div className="sm:col-span-2 grid grid-cols-2 gap-2 p-1 rounded-full border" style={{ borderColor: "rgba(11,27,61,0.15)" }} data-testid="book-gift-toggle">
    {[{ v: false, label: "For my child" }, { v: true, label: "A gift for a little swimmer" }].map((o) => (
      <button key={o.label} type="button" onClick={() => onChange(o.v)}
        className="inline-flex items-center justify-center gap-2 rounded-full px-4 py-2.5 font-body text-xs sm:text-sm transition-colors"
        style={isGift === o.v ? { backgroundColor: "var(--navy)", color: "#fff" } : { color: "var(--navy)" }}
        data-testid={o.v ? "book-gift-option-gift" : "book-gift-option-self"}>
        {o.v && <Gift size={15} />} {o.label}
      </button>
    ))}
  </div>
);

export const GiftFields = ({ inputCls, inputStyle, set }) => (
  <div className="sm:col-span-2 grid sm:grid-cols-2 gap-5 p-5 rounded-2xl" style={{ backgroundColor: "rgba(43,168,160,0.07)" }} data-testid="book-gift-fields">
    <p className="sm:col-span-2 font-body text-sm leading-relaxed" style={{ color: "var(--muted)" }}>
      Coach Mimi will reach out to the child's parent or guardian privately for photos and consent — we'll keep the surprise if you ask us to.
    </p>
    <label className="block">
      <span className="overline block mb-2" style={{ color: "var(--navy)" }}>Child's Parent Name *</span>
      <input required className={inputCls} style={inputStyle} data-testid="book-field-recipient_parent_name" onChange={(e) => set("recipient_parent_name", e.target.value)} />
    </label>
    <label className="block">
      <span className="overline block mb-2" style={{ color: "var(--navy)" }}>Parent's Email or Phone *</span>
      <input required className={inputCls} style={inputStyle} data-testid="book-field-recipient_parent_contact" onChange={(e) => set("recipient_parent_contact", e.target.value)} />
    </label>
  </div>
);
